<ng-template #orderMenu let-record>
  <div class="menu">
    <div class="menu-item">
      <button (click)="sendToTop(record)" mat-menu-item>Move to Top</button>
    </div>
    <div class="menu-item">
      <button (click)="sendToBottom(record)" mat-menu-item>Move to Bottom</button>
    </div>
  </div>
</ng-template>

<div class="table-header">
  <div>
    <h4>{{ tableTitle }}</h4>
  </div>
</div>

<table
  (cdkDropListDropped)="onRowDropped($event)"
  [cdkDropListDisabled]="!sortable"
  [dataSource]="dataSource"
  cdkDropList
  cdkDropListAutoScrollStep="10"
  class="mat-elevation-z3 width-100"
  mat-table
>
  <ng-container matColumnDef="index">
    <th *matHeaderCellDef mat-header-cell></th>
    <td *matCellDef="let element; let i = index" mat-cell>{{ i + 1 }}</td>
  </ng-container>

  <ng-container matColumnDef="source">
    <th *matHeaderCellDef mat-header-cell>Source</th>
    <td *matCellDef="let element" mat-cell>{{ element.source }}</td>
  </ng-container>

  <ng-container matColumnDef="type">
    <th *matHeaderCellDef mat-header-cell>Type</th>
    <td *matCellDef="let element" mat-cell>{{ element.type?.label }}</td>
  </ng-container>

  <ng-container matColumnDef="fileName">
    <th *matHeaderCellDef mat-header-cell>File Name</th>
    <td *matCellDef="let element" mat-cell>
      <a
        routerLink="/document/{{ element.documentUuid }}"
        target="_blank"
        [matTooltip]="element.fileName"
        [matTooltipDisabled]="element.fileName.length <= fileNameTruncLen"
      >
        {{ element.fileName }}
      </a>
    </td>
  </ng-container>

  <ng-container matColumnDef="uploadedAt">
    <th *matHeaderCellDef mat-header-cell>Upload Date</th>
    <td *matCellDef="let element" mat-cell>{{ element.uploadedAt | momentFormat }}</td>
  </ng-container>

  <ng-container matColumnDef="action">
    <th *matHeaderCellDef mat-header-cell>Action</th>
    <td *matCellDef="let element" mat-cell>
      <button (click)="onDownload(element.uuid, element.fileName)" class="action-btn" mat-icon-button title="Download">
        <mat-icon>download</mat-icon>
      </button>
    </td>
  </ng-container>

  <ng-container matColumnDef="sorting">
    <th *matHeaderCellDef mat-header-cell></th>
    <td *matCellDef="let element" class="drag-cell" mat-cell>
      <mat-icon>drag_indicator</mat-icon>
    </td>
  </ng-container>

  <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
  <tr
    (contextmenu)="openMenu($event, row)"
    (mousedown)="clearMenu()"
    *matRowDef="let row; columns: displayedColumns"
    [ngClass]="{
      draggable: sortable,
      selected: row.uuid === selectedRecord
    }"
    cdkDrag
    cdkDragLockAxis="y"
    mat-row
    style="background-color: #fff"
  ></tr>
  <tr *matNoDataRow class="mat-row">
    <td class="text-center" colspan="4">No files</td>
  </tr>
</table>
